// extracted by mini-css-extract-plugin
export default {"container":"DuplicateCell_container__navKW","first-row":"DuplicateCell_first-row__B0tR+","firstRow":"DuplicateCell_first-row__B0tR+","row":"DuplicateCell_row__BfpKw"};